import { useQueryClient } from '@tanstack/react-query';
import { cacheKeys, useCustomMutation } from '../../graphql';

const UPDATE_ALERTS_STATUS = `
  mutation updateAlertsStatus($input: UpdateAlertsStatusInput!) {
    workflow {
      updateAlertsStatus(input: $input) {
        success
      }
    }
  }
`;

export const useUpdateAlertsStatus = () => {
  const queryClient = useQueryClient();
  
  const mutation = useCustomMutation({
    query: UPDATE_ALERTS_STATUS,
    options: {
      onSuccess: () => {
        // Invalidate all workflow list queries to refresh the data
        queryClient.invalidateQueries({
          queryKey: cacheKeys('workflow').lists(),
        });
      },
    },
  });

  return mutation;
};
